import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

const images = [
  "https://i.ibb.co/tPrMYyS/independe-at-manav.jpg",
  "https://i.ibb.co/KhbSYwY/SW-05.jpg",
  "https://i.ibb.co/pKhzRbw/Ghigh-Comissioner-agreement.jpg",
  "https://i.ibb.co/wzsrhdk/Gam-ind-grad-with-fift-presiden.jpg",
  "https://i.ibb.co/kGCQ05w/Hcommisoner-lights.jpg",
  "https://i.ibb.co/VD9tsVb/manav-highcom-Gam-ind.jpg",
];

const HeroSection = () => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative text-white h-[80vh] flex items-center justify-center overflow-hidden">
      {images.map((image, index) => (
        <div
          key={index}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out"
          style={{
            backgroundImage: `url(${image})`,
            opacity: index === currentImageIndex ? 1 : 0,
          }}
        />
      ))}
      <div className="absolute inset-0 bg-black opacity-60"></div>

      <div className="relative max-w-screen-lg mx-auto text-center px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 relative z-10 leading-tight">
        Welcome To Gam-Ind Students Association 
        </h1>
        <p className="text-lg mb-8">
          Supporting Gambian students in India through empowerment, collaboration,
          and development initiatives.
        </p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={() => navigate("/resources")}
            className="bg-red-500 hover:bg-red-600 text-white text-lg md:text-xl font-bold py-2 px-6 rounded-lg transition-colors duration-200"
          >
            Learn More
          </button>
          <button
            onClick={() => navigate("/events")}
            className="bg-white hover:bg-gray-100 text-gray-900 text-lg md:text-xl font-bold py-2 px-6 rounded-lg transition-colors duration-200"
          >
            Events
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

